const countries = require('./countries.json');
exports.countries = countries


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/country-data/index.js
// module id = 260
// module chunks = 29